'use strict';

module.exports = {
  name: '使用者帳號資料',
  schema: {
    type: 'Object',
    contents: {
      account: {
        type: 'String',
        name: '帳號',
        unique: true
      },
      password: {
        type: 'String',
        name: '設定密碼'
      },
      group: {
        type: 'ObjectId',
        reference: 'groups',
        refKeys: ['account'],
        name: 'group'
      },
      groups: {
        type: 'Array',
        name: 'groups',
        contents: [{
          type: 'ObjectId',
          reference: 'groups',
          refKeys: ['account']
        }]
      }
    }
  },
  index: {
    primary: {
      key: {
        account: 1
      },
      unique: true
    }
  },
  ui: {
    list: {
      columns: [{ key: 'account', width: 150 }, { key: 'group', width: 150 }, { key: 'groups', width: 300 }]
    },
    editor: {
      groups: [{
        name: 'edit',
        rows: [[{ key: 'account' }], [{ key: 'password' }], [{ key: 'group' }], [{ key: 'groups' }]]
      }]
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/coact/models/users.js
// module id = 1745
// module chunks = 0